import { Box, Typography, styled } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';
import { generateNamesObject } from '../../utils';
import { usePrevious } from '../../hooks';

export const changeIndicationClasses = generateNamesObject(['root', 'blink1', 'blink2'], 'ChangeIndication');

const Container = styled(Box)(({ theme }) => ({
    [`& .${changeIndicationClasses.blink1}`]: {
        animation: `blink1 1500ms ${theme.transitions.easing.easeOut} 1`,
    },
    [`& .${changeIndicationClasses.blink2}`]: {
        animation: `blink2 1500ms ${theme.transitions.easing.easeOut} 1`,
    },
    '@keyframes blink1': {
        '0%': {
            color: theme.palette.text.primary,
        },
        '50%': {
            color: theme.palette.market.up,
        },
        '100%': {
            color: theme.palette.text.primary,
        },
    },
    '@keyframes blink2': {
        '0%': {
            color: theme.palette.text.primary,
        },
        '50%': {
            color: theme.palette.market.down,
        },
        '100%': {
            color: theme.palette.text.primary,
        },
    },
}));

export const ChangeIndication: React.FunctionComponent<
    PropsWithChildren<{
        value: number;
    }>
> = ({ value, children }) => {
    const currentValue = value;
    const prevValue = usePrevious(value) || 0;
    return (
        <Container>
            <Typography
                className={clsx(
                    changeIndicationClasses.root,
                    prevValue > currentValue ? changeIndicationClasses.blink2 : changeIndicationClasses.blink1,
                )}
            >
                {children}
            </Typography>
        </Container>
    );
};
